import {prospectusGraphql, prospectusUrl} from '../api';
import {verifyRecaptcha} from '../helpers'

const logUserIn = ({email, password}) => async(dispatch) => {

    // verify the recaptcha.
    if ( ! verifyRecaptcha( prospectusUrl, 'login' ) ) {
		dispatch({
			type : 'FAILED_USER_LOG_IN',
			payload : [
				'oh no, looks like you failed the bot check.'
			],
		})
	}

    // Then dependant on the result either set the user,
    // Or set a login error.
    const response = await fetch( prospectusGraphql(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(
            { query: `
            mutation LoginUser {
                login(input: {clientMutationId: "login", username: "${email}", password: "${password}"}) {
                    user {
                        id
                        jwtAuthToken
                        jwtRefreshToken
                        name
                        userProspectus
                    }
                }
            }`
        }),
    })

    let data = await response.json();

    // If we did auth
    if ( data.data && data.data.login && data.data.login.user.jwtAuthToken ) {

        dispatch({
            type : 'USER_LOGGED_IN',
            payload : data.data.login.user,
        })
    }

    // If we didn't authenitcate
    if ( data.errors ) {

        dispatch({
            type : 'FAILED_USER_LOG_IN',
            payload : [
                'Failed to Authenticate'
            ],
        })
    }
}

export default logUserIn;